<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/arragnge/arrange' }">排班</el-breadcrumb-item>
      <el-breadcrumb-item>批量删除</el-breadcrumb-item>

      <el-link type="primary" style="float:right" @click="tosetting()"><i class="el-icon-back"></i> 返回</el-link>
    </el-breadcrumb>
    <div class="csss">
      <el-form :inline="true" :model="formInline"  style="display:flex;flex-wrap:wrap;padding-top:30px">
         <!-- <el-form-item label="搜索：">
          <el-input size="mini" placeholder="请输入姓名/手机号"  style="width:150px" v-model="selectMembersName"  auto-complete="off"></el-input>
         </el-form-item> -->
        <el-form-item :label="WZCDName+'：'"  prop="Site" v-if="IsCD == 1">
            <el-select v-model="Site" clearable placeholder="请选择" size="mini" style="width:150px">
                  <el-option
                    v-for="item in siteList"
                    :key="item.ID"
                    :label="item.SiteName"
                    :value="item.ID">
                  </el-option>
                </el-select>
        </el-form-item>
        <el-form-item label="项目：" prop="objID" >
            <el-select clearable v-model="objID" placeholder="请选择" size="mini" style="width:150px">
                  <el-option
                    v-for="item in projectList"
                    :key="item.ID"
                    :label="item.ProjectName"
                    :value="item.ID">
                  </el-option>
                </el-select>
        </el-form-item>
       <el-form-item label="项目类型：" prop="RowType" v-if="RowTypeList.length>1">
              <el-select clearable v-model="RowType" placeholder="请选择" size="mini" style="width:150px">
                      <el-option
                        v-for="item in RowTypeList"
                        :key="item.ID"
                        :label="item.RowTypeName"
                        :value="item.ID">
                      </el-option>
                    </el-select>
      </el-form-item>
        <el-form-item label="员工：" prop="RowType" >
              <el-select clearable v-model="LoginID" placeholder="请选择" size="mini" style="width:150px">
                      <el-option
                        v-for="item in perList"
                        :key="item.ID"
                        :label="item.Name"
                        :value="item.ID">
                      </el-option>
                    </el-select>
            </el-form-item>
        <el-form-item label="时间:">
            <el-date-picker
              v-model="tdate"
              type="date"
              placeholder="选择日期"
              size="mini"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              style="width:170px"
              >
            </el-date-picker>
               至
            <el-date-picker
              v-model="mdate"
              type="date"
              placeholder="选择日期"
              size="mini"
              style="width:170px"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              >
            </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button  size="mini" type="danger"     @click="handleDel()" >批量删除</el-button>
        </el-form-item>
      </el-form>
    </div>

    
    <el-table :data="tableData" highlight-current-row v-loading="loading" size="mini"    @selection-change="handleSelectionChange"  element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
          <el-table-column
                type="selection"
                width="55">
        </el-table-column>
          <el-table-column  prop="Phone" label="项目时间"  width="170" >
            <template slot-scope="scope"> 
              <div class="flexc-cen-x" style="width:100%">
                {{scope.row.SKtime}} {{scope.row.startTime}}
              </div>
            </template>
          </el-table-column>
          <el-table-column  prop="ProjectName" label="项目名称"  align="center">
          </el-table-column>
          <el-table-column prop="Timelength" label="项目时长" align="center" >
          </el-table-column>
          <el-table-column  prop="terName" label="服务人员"  align="center">

      
          </el-table-column>
          <el-table-column  prop="SiteName" :label="WZCDName" v-if="IsCD == 1"  align="center">
          </el-table-column>



    </el-table>
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!--列表-->

    <!-- 分页组件 -->
    
    <!-- 编辑界面 -->
    <el-drawer :wrapperClosable= false title="详情" :visible.sync="editFormVisible" :direction="direction" size="30%">
      <div class="bottomBORD">
        <div style="margin-left:2%;font-size:15px">服务信息</div>
          <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:30px">
              <div style="color:#7e7e7e;width:80px">状态：</div>
              <div> <span class="Info" v-if="mainList.state == 0">
                    学员取消
                  </span>
                  <span class="coBlue" v-if="mainList.state == 1">
                   已预约
                  </span>
                  <span class="Success" v-if="mainList.state == 2">
                    已{{typeName}}
                  </span>
                  <span class="Danger" v-if="mainList.state == 3">
                   未到
                  </span>
                  <span class="Info" v-if="mainList.state == 4">
                    机构取消
                  </span>
                  <span class="Warning" v-if="mainList.state == 5">
                   请假
                  </span>
              </div>
          </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">项目名称：</div>
                  <div class="flexc-cen-x">
                    <img :src="mainList.ProjectHeadUrl" style="width:25px;height:25px;border-radius:100%" alt="">
                    <div style="margin-left:5px;font-size:13px">{{mainList.ProjectName}}</div>
                  </div>
            </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">服务人员：</div>
                    <div class="flexc-cen-x">
                      <img :src="mainList.terHeadUrl" v-if="mainList.terHeadUrl!='' " style="width:25px;height:25px;border-radius:100%" alt="">
                      <img v-if="mainList.terHeadUrl =='' " src="../../assets/img/head.png" style="width:25px;height:25px;border-radius:100%" alt="">
                    <div style="margin-left:5px;font-size:13px">{{mainList.terName}}</div>
                  </div>
            </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px" v-if="IsCD == 1">{{WZCDName}}</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">{{mainList.SiteName}}</div>
                  </div>           
            </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">项目时间：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">{{mainList.SKtime}} {{mainList.startTimeNew}}</div>
                  </div>
            </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">项目时长：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">{{mainList.Timelength}} 分钟</div>
                  </div>
            </div>
      </div>
      <div class="bottomBORD" style="margin-top:30px">
        <div style="margin-left:2%;font-size:15px">顾客信息</div>

            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:30px">
                  <div style="color:#7e7e7e;width:80px">姓名：</div>
                    <div class="flexc-cen-x">
                      <img :src="row.HeadUrl" v-if="row.HeadUrl!='' " style="width:25px;height:25px;border-radius:100%" alt="">
                      <img v-if="row.HeadUrl =='' " src="../../assets/img/head.png" style="width:25px;height:25px;border-radius:100%" alt="">
                    <div style="margin-left:5px;font-size:13px">{{row.Name}}</div>
                  </div>
            </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">预约人数：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">{{mainList.PreAboutCount}}</div>
                  </div>
            </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">预约时间：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">{{mainList.addTime}}</div>
                  </div>
    
               
            </div>
            <div class="flexc-cen-x" v-if="mainList.isZF == 1" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">付款金额：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">￥{{mainList.PayAmount}}</div>
                  </div>
            </div>

      </div>
      <div class="bottomBORD" style="margin-top:30px;margin-bottom:100px"  v-if=" mainList.listPreAboutInfo && mainList.listPreAboutInfo.length > 0">
        <div style="margin-left:2%;font-size:15px;margin-bottom:30px">预约信息</div>
            <div v-for="(items,index) in mainList.listPreAboutInfo" v-if="items.state !=3" style="margin-bottom:15px;">
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">{{items.Title}}:</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">{{items.FormsInfo}}</div>
                  </div>
            </div>
           </div>
      </div>
        <div class="demo-drawer__footer flex-r-x"  style="width:30%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
           
             @click="closeDialog"
            >确定</el-button
          >
        </div>
    </el-drawer>

    <el-dialog :title="typeName" :visible.sync="hexiaoShow" width="40%">

        <el-form label-width="120px" >
          <el-form-item label="使用核销码:" prop="isCode">
            <el-radio-group v-model="isCode">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="核销码" prop="number" v-if="isCode == 1">
            <el-input size="small" placeholder="请输码" v-model="code"  auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="金额" prop="number" v-if="mainList.vipID == -1 && isCode == 0">
            <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
            元
          </el-form-item>
          <el-form-item label="次数" prop="number" v-if="mainList.vipID != -1 && isCode == 0" >
            <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
          </el-form-item> 
          
          <el-form-item label="备注:" prop="Note">
              <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button size="small" type="primary" :loading="loading"  @click="sure()">确定</el-button>
        </div>
      </el-dialog>
    <el-dialog title="其他操作" :visible.sync="otherShow" width="40%" >

        <el-form label-width="120px">
            <el-form-item label="原因："  prop="state">
              <el-select v-model="state" clearable placeholder="请选择" size="mini">
                    <el-option
                      v-for="item in stateList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
            </el-form-item>
          <el-form-item label="扣课时:" prop="isxk">
            <el-radio-group v-model="isxk">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="金额" prop="number" v-if="mainList.vipID == -1 && isxk == 1">
            <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
            元
          </el-form-item>
          <el-form-item label="次数" prop="number" v-if="mainList.vipID != -1 && isxk == 1" >
            <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
          </el-form-item>
          <el-form-item label="备注:" prop="Note">
              <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="otherShow = false">取消</el-button>
          <el-button size="small" type="primary" :loading="loading"  @click="sure1()">确定</el-button>
        </div>
    </el-dialog>
    <!-- </el-dialog> -->

  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import CropperImage from "../../components/CropperImage";
import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      formValidate: {
        mainImage: "",
      },
      tdate:'',
      mdate:'',
      code:'',
      row:'',
      selectMembersName:"",
      otherShow:false,
      Note:'',
      Site:'',
      activeName: 'first',
      value:true,
      direction: "ltr",
      projectList:[],
      passShow:false,
     IsCD:localStorage.getItem("IsCD"),
      WZCDName:localStorage.getItem('WZCDName'),
      input:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      chongShow:false,
      SelectStoresID:this.$route.params.id,
      title: '添加',
      tableData:[],
      RowType:'',
     RowTypeList:[],
      Pwd:'',
      objID:'',
      site:'',
      mainList:[],
      DianList:[],
      perList:[],
      hexiaoShow:false,
      
    WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
      LoginID:'',
      stateList:[
     
      
        {
          value:3,
          label:'未到'

        },
      
         {
          value:5,
          label:'请假'

        },
      ],
  
    //   SelectStoresID:1,
      editForm: {
        LoginName:"",
        Phone:"",
        Name:"",
        pwd:"",
        money:"",
        ShopName:"",
        token: localStorage.getItem('token')
      },
      money:1.00,
      // rules表单验证

      rules: {
        LoginName: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
          Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
          Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
          pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
          money: [{ required: true, message: '请输入余额', trigger: 'blur' }],
          ShopName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      isCode:0,
      number:1,
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      isxk:0,
      state:'',
      Limits:[],
      q1:false,
      q2:false,
      q3:false,
      q4:false,
      typeName:'',
      multipleSelection:[],
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
      this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
      if(localStorage.getItem('StoresType')== 1){
          this.name = '签到'
          this.nmae1 = localStorage.getItem('zzjy') 
          this.typeName = '签到'
        
      }  else {
          this.typeName = '核销'
          this.name = '核销'
          this.nmae1 = localStorage.getItem('zzjy') 
      }     
      if(localStorage.getItem('isAdmin') == 1){
          this.q1 = true
          this.q2 = true
          this.q3 = true
          this.q4 = true
      }
    this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {
          if(items == 22){
            this.q1 = true
          }
          if(items == 23){
            this.q2 = true
          }
          if(items == 24){
            this.q3 = true
          }
          if(items == 25){
            this.q4 = true
          }
   })
          var date = new Date();
          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var day = date.getDate();
          if (month < 10) {
          month = '0' + month;
          }
          if (day < 10) {
          day = '0' + day;
          }
          var nowDate = 
        // this.data.[0] = 
      this.tdate = year + '-' + month + '-' + day;
      this.mdate = year + '-' + month + '-' + day;
    
      this.getDianList()
      this.getSiteList()
      this.getProjectList()
      this.getList()
      this.getRowType()
      this.getperList()
      // this.ge1tList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
     getperList(){
      var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:1000
      }
  
      var that = this
      this.ajax('getlistStaffpb.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
         
              that.perList= res.data
                 if(localStorage.getItem("Iswyg") == 1){
                  var list = {
                    Name:'无'+that.WZYGName,
                    ID:0,
                  }
                  that.perList.push(list)
              }
    
          } 
       })
  },
      handleDel(){
         this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.del()
        })
        .catch(() => {
          
        })
      },
      del(){
        var list = []
        this.multipleSelection.forEach(items => {
           list.push(items.ID)
        });
      
        var data = { 
            SelectStoresID:this.SelectStoresID,        
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            RowClassIDs:list.join(',')
        }
  
      var that = this
      this.ajax('delAllRowClass.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                    that.$message({
                      type: "success",
                      message: "删除成功",duration:2000,
                    });
                that.getList()
    
          } 
       })
      },
       handleSelectionChange(val) {
        this.multipleSelection = val;
        console.log(this.multipleSelection)
      },
    getRowType(){
       var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
      }
  
      var that = this
      this.ajax('getListRowTypeSetting.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
         
                that.RowTypeList= res.data
    
          } 
       })
    },
    tosetting(){
              this.$router.go(-1)
      },
    changedian(){
      this.getSiteList()
      this.getProjectList()
     this.getList()
    },
    sure1(){
      console.log(this.state)
      if(this.state == ''){
        this.$message({ type: "error", message: "请选择原因" ,duration:1000});
                          return;
      }
      if(this.money == 0  && this.mainList.vipID == -1 && this.isxk == 1){
        this.$message({ type: "error", message: "请输入消耗金额" ,duration:1000});
                          return;
      }
       if(this.number == 0  && this.mainList.vipID != -1 && this.issk == 1){
        this.$message({ type: "error", message: "请输入消耗次数" ,duration:1000});
                          return;
      }
    
        var data = { 
                SelectStoresID:this.SelectStoresID,        
                StoresID:localStorage.getItem("StoresID"),
                token: localStorage.getItem("token"),
                PreAboutID:this.mainList.ID,
                loginID:localStorage.getItem("LoginID"),
                Note:this.Note,
                sourceName:localStorage.getItem("Name"),
                isxk:this.isxk,
                state:this.state,
                ConsumptionOfClass:this.number,
                singlePrice:this.money,

              
              }
              var that = this
              this.ajax('editPreAboutStateQT.aspx',JSON.stringify(data),"POST",function(res){

                if (res.orsuccess == "1") {
                    that.$message({
                      type: "success",
                      message: "操作成功",duration:2000,
                    });
                    that.otherShow = false
                    // that.getType()
                    that.getList()
                    //  that.provinceList = res.data
                  }

              })
          
      
    
    },
    sure(){

      if(this.money == 0  && this.mainList.vipID == -1 && this.isCode == 0){
        this.$message({ type: "error", message: "请输入消耗金额" ,duration:1000});
                          return;
      }
       if(this.number == 0  && this.mainList.vipID != -1 && this.isCode == 0){
        this.$message({ type: "error", message: "请输入消耗次数" ,duration:1000});
                          return;
      }
      if(this.code == '' && this.isCode == 1){
        this.$message({ type: "error", message: "请输入核销码" ,duration:1000});
                          return;
      }
      var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          PreAboutID:this.mainList.ID,
          loginID:localStorage.getItem("LoginID"),
          Note:this.Note,
          sourceName:localStorage.getItem("Name"),
          isCode:this.isCode,
          VerificationCode:this.code,
          ConsumptionOfClass:this.number,
          singlePrice:this.money,

        
        }
        var that = this
        this.ajax('editPreAboutState.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "操作成功",duration:2000,
              });
              that.hexiaoShow = false
              // that.getType()
              that.getList()
              //  that.provinceList = res.data
            }

        })
    },
    toOther(row){
      this.otherShow = true
      this.mainList = row
      this.state = ''
      this.Note = '',
      this.isxk = 0
      this.money = 0 
      this.number = 0
    },
    hexiao(row){
      this.mainList = row
      this.hexiaoShow = true
      this.iscode = 1
      this.money = 0 
      this.number = 0
    },
     hexiao1(){
   
      this.hexiaoShow = true
      this.iscode = 1
      this.money = 0 
      this.number = 0
    },

     getProjectList(){
        var data = { 
            SelectStoresID:this.SelectStoresID,        
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            pages:1,
            psize:200,
            ProjectTypeID:0
          // StaffTypeID:this.active
      }

      
        var that = this
      this.ajax('getListProject.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {

                that.projectList = res.data
              
          } 

      })
      },
        getSiteList(){
       var data = { 
        SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:200,

      }
  
        var that = this
      this.ajax('getListSite.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
            
                that.siteList = res.data
      
          } 

      })
    },
     getDianList(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
    },
    getList(){

      if(this.mdate < this.tdate){
        this.$message({ type: "error", message: "结束时间不得小于开始时间" ,duration:1000});
            return;
      }
 if(this.LoginID == ''){
        var id = -1
      } else {
        var id = this.LoginID
      }
      var data = { 
         SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
    
        //   selectMembersName:this.selectMembersName,
          SKtime:this.tdate,
          Etime:this.mdate,
          objID:this.objID,
          Site:this.Site,
          LoginID:id ,
          pages:this.formInline.page,
          psize:this.formInline.limit,
          RowType:this.RowType
      }
        var that = this
       this.ajax('getListRowClassTab.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
              that.tableData = res.data
              that.pageparm.total = res.allcount

            }
      })
    },

      handleClick(){

      },

    handlePassword(row){
      // this.editForm.ManageLoginID = row.ID
      this.Pwd = ''
      this.passShow = true

    },
    handleChong(row){
      this.editForm.ManageLoginID = row.ID
      this.editForm.money = row.money
       this.chongShow = true
      this.money = ''
    },
    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getList()
    },
    // 搜索事件
    
    search() {
      this.getList()
      
    },
    noSearch(){
        this.objID =''
        this.Site = ''
        this.LoginID = -1
        this.selectMembersName = ''
        var date = new Date();
          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var day = date.getDate();
          if (month < 10) {
          month = '0' + month;
          }
          if (day < 10) {
          day = '0' + day;
          }
          var nowDate = 
        // this.data.[0] = 
      this.date[0] = year + '-' + month + '-' + day;
      this.date[1] = year + '-' + month + '-' + day;
        this.formInline.page = 1
      this.formInline.limit = 10
      this.pageparm={
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
      this.getList()
    },
    //显示编辑界面
    handleEdit: function(row) {
      this.row = row
        var data = { 
         SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          PreAboutID:row.ID
        
      }
        var that = this
       this.ajax('getPreAboutInfo.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
              that.mainList  = res.data
               that.editFormVisible = true
            }
      })
  
      

    },
    // 编辑、增加页面保存方法
    submitForm(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
            if(this.title == '添加'){
                this.add()
            }else {
                this.edit()
            }
        } else {
          return false
        }
      })
    },



    handlejie(row) {
      if(row.Isdisable == 0){
 this.$confirm('确定要禁用吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.jie(row)
        })
        .catch(() => {
          
        })
      } else {
this.$confirm('确定要解禁吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.jie1(row)
        })
        .catch(() => {
          
        })
      }
 
     
    },

    todel(items){
      if(items.isZF == 1){
   this.$confirm("确定要取消预约吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
            var data = { 
              SelectStoresID:this.SelectStoresID,
              StoresID:localStorage.getItem("StoresID"),
              token: localStorage.getItem("token"),
              PreAboutID:items.ID,
              loginID:localStorage.getItem("LoginID"),
              Note:'',
            }
            var that = this
            this.ajax('editPreAboutStateTK.aspx',JSON.stringify(data),"POST",function(res){

              if (res.orsuccess == "1") {
                  that.$message({
                    type: "success",
                    message: "取消成功",duration:2000,
                  });
            
                  that.getList()
              
                  //  that.provinceList = res.data
                }

            })
            })
            .catch(() => {

            });
      

      } else {
          if(items.RowClassTypeqt == 1){ 
              this.$confirm("确定要取消预约吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
            var data = { 
              SelectStoresID:this.SelectStoresID,
              StoresID:localStorage.getItem("StoresID"),
              token: localStorage.getItem("token"),
              PreAboutID:items.ID,
              loginID:localStorage.getItem("LoginID"),
              Note:'',
            }
            var that = this
            this.ajax('editPreAboutStateQXQT.aspx',JSON.stringify(data),"POST",function(res){

              if (res.orsuccess == "1") {
                  that.$message({
                    type: "success",
                    message: "取消成功",duration:2000,
                  });
            
                  that.getList()
              
                  //  that.provinceList = res.data
                }

            })
            })
            .catch(() => {

            });
      

              } else{
                  this.$confirm("确定要取消预约吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
            var data = {
                SelectStoresID:this.SelectStoresID,
                StoresID:localStorage.getItem("StoresID"),
                token: localStorage.getItem("token"),
                PreAboutID:items.ID,
                loginID:localStorage.getItem("LoginID"),
                Note:'',
            }
            var that = this
            this.ajax('editPreAboutStateQX.aspx',JSON.stringify(data),"POST",function(res){

              if (res.orsuccess == "1") {
                  that.$message({
                    type: "success",
                    message: "取消成功",duration:2000,
                  });
            
                  that.getList()
            
                  //  that.provinceList = res.data
                }

            })
            })
            .catch(() => {
            
            });
      

            }
      }

    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.delete(row)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.hexiaoShow = false,
      this.passShow = false,
      this.chongShow = false,
      this.editFormVisible = false
    }
  }
}
</script>
<style>
.csss .el-form-item {
    margin-bottom: 5px;
}

</style>
<style scoped>
.bottomBORD{
  padding-bottom: 30px;
  width:100%;
  border-bottom: 1px solid #e9e9e9;
}

.main{
  position: absolute;
}
.content{
    font-size: 12px;
  color: #999;
  line-height: 20px;
}
.titleMain{
    font-size: 14px;
    color: #191919;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.offline___NHq4e {
    position: absolute;
    top: -1px;
    right: -1px;
    padding: 0.5px 4px 0.5px 4px;
    /* width: 64px; */
    /* height: 22px; */
    background: rgba(255, 101, 247, 0.04);
    border-radius: 0 8px 0 8px;
    border: 1px solid rgba(187, 14, 255, 0.2);
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    color: #b336fc;
}
.box{
  position: relative;
    width: calc((100% - 80px)/4);
    padding: 20px;
    box-sizing: border-box;
    display: inline-block;
    margin-right: 16px;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
    height: 130px;
}
@media screen and ( max-width: 1400px ) {
  .box{
    cursor: pointer;
    width: calc((100% - 60px)/3);
  }
}
.box:hover{
  box-shadow: 0 4px 16px 0 rgb(0 0 0 / 16%);
}
.shadow:hover {
    border:1px solid #808080;border-radius:2px
}
.shadow {
    border:1px solid #ffffff;border-radius:2px
}

.xiang{
    padding: 1px 4px  1px 4px;
    background-color: #f7f7f7;
    border:1px solid #bbbbbb;
    border-radius: 3px;
    font-size: 10px;
    color:#bbbbbb;
}
  
/* .el-switch__core::after{
 height: 12px !important;
 width :12px !important;
} */
   
.title{
    margin-top: 10px;
    height: 30px;
    font-size: 13px;
    font-weight: bolder;
    border-radius: 3px;
    border-left: 5px solid #334157;

}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/arrange/delLesson.vue